/** Référence de comparaison "vs précédent" selon la période filtrée ("… par rapport {ref}") */
export const compareRefLabel = (period) => {
    const lastYear = new Date().getFullYear() - 1;
    const labels = {
        ytd: `à la même période en ${lastYear}`,
        "12m": "aux 12 mois précédents",
        quarter: `au même trimestre en ${lastYear}`,
        month: `au même mois en ${lastYear}`,
    };
    return labels[period] || "à la période précédente";
};

/** Texte d'aide de l'icône info à côté du toggle "vs précédent" */
export const compareHelpText = (period, on) => {
    const ref = compareRefLabel(period);
    return on
        ? `Survolez une valeur pour afficher son évolution par rapport ${ref}.`
        : `Activez pour comparer ${ref}, puis survolez les valeurs.`;
};
